import { _ReactPixi, Container } from '@pixi/react'
import { Assets } from 'pixi.js'
import { Button, chipSetService, soundManager, SoundType, useChipSetStore } from '@slot-nx/core'

import hs_bet_minus_normal from '../../asset/images/bet/bet_minus_normal.png'
import hs_bet_minus_hover from '../../asset/images/bet/bet_minus_hover.png'
import hs_bet_minus_unable from '../../asset/images/bet/bet_minus_unable.png'
import hs_bet_minus_click from '../../asset/images/bet/bet_minus_click.png'

import hs_bet_plus_normal from '../../asset/images/bet/bet_plus_normal.png'
import hs_bet_plus_hover from '../../asset/images/bet/bet_plus_hover.png'
import hs_bet_plus_unable from '../../asset/images/bet/bet_plus_unable.png'
import hs_bet_plus_click from '../../asset/images/bet/bet_plus_click.png'
import { useSelector } from '@xstate/react'
import { useMemo } from 'react'
import { GameState, sweetBombMachine } from '../../machine/sweetbombMachine'

import PointLike = _ReactPixi.PointLike

Assets.addBundle('Bet', {
  hs_bet_minus_normal: {
    src: hs_bet_minus_normal,
    loadParser: 'loadTextures',
  },
  hs_bet_minus_hover: {
    src: hs_bet_minus_hover,
    loadParser: 'loadTextures',
  },
  hs_bet_minus_unable: {
    src: hs_bet_minus_unable,
    loadParser: 'loadTextures',
  },
  hs_bet_minus_click: {
    src: hs_bet_minus_click,
    loadParser: 'loadTextures',
  },
  hs_bet_plus_normal: {
    src: hs_bet_plus_normal,
    loadParser: 'loadTextures',
  },
  hs_bet_plus_hover: {
    src: hs_bet_plus_hover,
    loadParser: 'loadTextures',
  },
  hs_bet_plus_unable: {
    src: hs_bet_plus_unable,
    loadParser: 'loadTextures',
  },
  hs_bet_plus_click: {
    src: hs_bet_plus_click,
    loadParser: 'loadTextures',
  },
})

interface BetProps {
  x: number
  y: number
  scale?: PointLike
}

export const Bet = ({ scale = [1, 1], ...props }: BetProps) => {
  const width = 452
  const height = 78
  const chipSetStore = useChipSetStore()
  const currentState = useSelector(sweetBombMachine, state => state)

  const canPressButton = useMemo(() => {
    return currentState.matches(GameState.mainGame)
  }, [currentState])

  return (
    <Container name="Bet" position={[props.x, props.y]} width={width} height={height} scale={scale}>
      <Button
        name="minus button"
        defaultView="hs_bet_minus_normal"
        hoverView="hs_bet_minus_hover"
        disabledView="hs_bet_minus_unable"
        pressedView="hs_bet_minus_click"
        enabled={chipSetStore.computed.hasPrev && canPressButton}
        x={0}
        y={0}
        width={78}
        height={78}
        onPressing={() => {
          soundManager.play(SoundType.stake_minus)
        }}
        onPress={() => {
          chipSetService.selectPreviousChip()
        }}
      />

      <Button
        name="plus button"
        defaultView="hs_bet_plus_normal"
        hoverView="hs_bet_plus_hover"
        disabledView="hs_bet_plus_unable"
        pressedView="hs_bet_plus_click"
        enabled={chipSetStore.computed.hasNext && canPressButton}
        x={width - 78}
        y={0}
        width={78}
        height={78}
        onPressing={() => {
          soundManager.play(SoundType.stake_plus)
        }}
        onPress={() => {
          chipSetService.selectNextChip()
        }}
      />
    </Container>
  )
}
